import {
  AccessDenied,
  CanAccess,
  ListBase,
  Title,
  WithListContext,
} from 'react-admin';
import { useTranslate } from 'ra-core';
import { ReportingFiltersForm } from './ReportingFiltersForm';
import { DailyTrendChart } from './TrendChart';
import ListPageWrapper from '../components/wrappers/ListPageWrapper';
import StatsCards from './StatsCards';
import OfferPerformanceList from './OfferPerformanceGrid';
import BrandPerformanceGrid from './BrandPerformanceGrid';
import EmptyState from '../dashboard/EmptyState';

const ReportingPage = () => {
  const t = useTranslate();

  return (
    <CanAccess action="list" resource="reports" accessDenied={<AccessDenied />}>
      <ListPageWrapper>
        <Title title={t('reporting.title')} />
        <ListBase
          resource="reports/offers-by-date"
          perPage={Infinity}
          sort={{ field: 'date', order: 'ASC' }}
          storeKey={false}
          disableSyncWithLocation
        >
          <ReportingFiltersForm />
          <div className="bg-background/80">
            <WithListContext
              render={({ isFetching, total }) => {
                return (
                  <div className="grid gap-4">
                    <div className="min-h-[6px]">
                      {isFetching && (
                        <div className="h-1 w-full overflow-hidden rounded-full bg-border">
                          <div className="h-full w-1/2 bg-primary/70 animate-pulse rounded-full" />
                        </div>
                      )}
                    </div>

                    {total === 0 ? (
                      <EmptyState status="noResult" />
                    ) : (
                      <>
                        <StatsCards />
                        <DailyTrendChart />
                        <BrandPerformanceGrid />
                        <OfferPerformanceList />
                      </>
                    )}
                  </div>
                );
              }}
            />
          </div>
        </ListBase>
      </ListPageWrapper>
    </CanAccess>
  );
};

export default ReportingPage;
